import React from 'react';

const Input = ({ label, value, onChange, placeholder, type = 'text', icon, rightIcon, error, style, textarea, rows = 3, ...props }) => (
  <div style={{ marginBottom: 16, ...style }}>
    {label && <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#A1A1AA', marginBottom: 8, letterSpacing: '0.01em' }}>{label}</label>}
    <div style={{ position: 'relative' }}>
      {icon && <span style={{ position: 'absolute', left: 14, top: textarea ? 14 : '50%', transform: textarea ? 'none' : 'translateY(-50%)', color: '#71717A', fontSize: 18, display: 'flex' }}>{icon}</span>}
      {textarea ? (
        <textarea value={value} onChange={onChange} placeholder={placeholder} rows={rows}
          style={{
            width: '100%', padding: `14px ${icon ? 42 : 16}px 14px ${icon ? 42 : 16}px`,
            background: 'rgba(255,255,255,0.04)', border: `1px solid ${error ? '#EF4444' : 'rgba(255,255,255,0.08)'}`,
            borderRadius: 14, color: '#FFFFFF', fontSize: 15, fontFamily: 'Inter, sans-serif',
            resize: 'none', outline: 'none', transition: 'border-color 0.2s',
            lineHeight: 1.5,
          }}
          onFocus={(e) => e.target.style.borderColor = '#FF3D71'}
          onBlur={(e) => e.target.style.borderColor = error ? '#EF4444' : 'rgba(255,255,255,0.08)'}
          {...props}
        />
      ) : (
        <input type={type} value={value} onChange={onChange} placeholder={placeholder}
          style={{
            width: '100%', padding: `14px ${rightIcon ? 42 : 16}px 14px ${icon ? 42 : 16}px`,
            background: 'rgba(255,255,255,0.04)', border: `1px solid ${error ? '#EF4444' : 'rgba(255,255,255,0.08)'}`,
            borderRadius: 14, color: '#FFFFFF', fontSize: 15, fontFamily: 'Inter, sans-serif',
            outline: 'none', transition: 'border-color 0.2s',
          }}
          onFocus={(e) => e.target.style.borderColor = '#FF3D71'}
          onBlur={(e) => e.target.style.borderColor = error ? '#EF4444' : 'rgba(255,255,255,0.08)'}
          {...props}
        />
      )}
      {rightIcon && <span style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', color: '#71717A', fontSize: 18, display: 'flex', cursor: 'pointer' }}>{rightIcon}</span>}
    </div>
    {error && <p style={{ fontSize: 12, color: '#EF4444', marginTop: 6 }}>{error}</p>}
  </div>
);

export default Input;
